interface IProps {
  size: number;
}

export const InfoIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 8.97937C9 8.42708 9.44771 7.97937 10 7.97937C10.5523 7.97937 11 8.42708 11 8.97937V14.9794C11 15.5317 10.5523 15.9794 10 15.9794C9.44771 15.9794 9 15.5317 9 14.9794V8.97937Z"
      fill="currentColor"
    />

    <path
      d="M10 4.05115C9.44771 4.05115 9 4.49886 9 5.05115C9 5.60343 9.44771 6.05115 10 6.05115C10.5523 6.05115 11 5.60343 11 5.05115C11 4.49886 10.5523 4.05115 10 4.05115Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10Z"
      fill="currentColor"
    />
  </svg>
);
